import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { SigurIntegration } from "@/api/sigur";

interface IEditSigurIntegrationForm {
  name: string;
  location_id: number;
  credentials_id: number;
}

const editSigurIntegrationFields: InputField[] = [
  {
    label: "Название интеграции",
    name: "name",
    placeholder: "Сигур интеграция",
    type: "text",
    isRequired: true,
  },
  {
    label: "Локация",
    name: "location_id",
    placeholder: "",
    type: "location",
    isRequired: true,
  },
  {
    label: "Система замков",
    name: "credentials_id",
    placeholder: "",
    type: "lock-system",
    isRequired: true,
  },
];

export function EditSigurIntegrationModal({
  disclosure,
  sigurIntegration,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
  sigurIntegration: SigurIntegration | null;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);

  const handleError = useErrorHandling();

  const onSubmit = (data: IEditSigurIntegrationForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      if (!sigurIntegration) {
        resolve(false);
        return;
      }

      api.sigur
        .update(sigurIntegration.id, {
          name: data.name,
          location_id: data.location_id,
          credentials_id: Number(data.credentials_id),
          owner_id: sigurIntegration.owner_id,
        })
        .then((_data) => {
          toast.success("Интеграция с Сигуром успешно обновлена");
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  const onDelete = () => {
    return new Promise<boolean>(async (resolve, _reject) => {
      if (!sigurIntegration) {
        resolve(false);
        return;
      }

      api.sigur
        .delete(sigurIntegration.id, sigurIntegration.credentials_id)
        .then((_data) => {
          toast.success("Интеграция с Сигуром успешно удалена");
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage } = handleError(err);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Редактирование интеграции с Сигуром"
      modalErrors={modalErrors}
      fields={editSigurIntegrationFields}
      defaultValues={
        sigurIntegration
          ? {
              name: sigurIntegration.name,
              location_id: sigurIntegration.location_id,
              credentials_id: String(sigurIntegration.credentials_id),
            }
          : undefined
      }
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
      onDelete={onDelete}
      submitButtonText="Сохранить"
      deleteButtonText="Удалить"
    />
  );
}
